import { Link } from 'react-router-dom';

export default function FareDisclaimer({ className = '' }) {
  return (
    <p className={`fare-disclaimer ${className}`.trim()}>
      *All fares are quoted in <strong>USD</strong>. Fares are round trip or one-way as shown and include taxes, carrier
      surcharges, and applicable service fees unless noted. Prices are based on availability at search time, may change
      without notice, and are not guaranteed until ticketed. See our{' '}
      <Link to="/flight/terms">Terms &amp; Conditions</Link> for full booking rules.
    </p>
  );
}
